import { Card } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { ethSepoliaDAI } from '../../utils/token-claim';
import MintToken from '../MintToken/MintToken';

export default function DAI() {
  return <div>
    <Card>
      <Card.Body>
        <Card.Title>DAI</Card.Title>
        <Card.Text>
          <Tabs
            defaultActiveKey="ethereum"
            id="usdc"
            className="mb-3"
          >
            <Tab eventKey="ethereum" title="ETHEREUM CHAIN">
              <MintToken currency="DAI" chain="ETHEREUM" mintHandler={ethSepoliaDAI} maxAmount={1000000} />
            </Tab>
          </Tabs>
        </Card.Text>
      </Card.Body>
    </Card>
  </div>
}